import React, { useEffect, useState } from 'react'
import iconSelectInput from '../../assets/iconSelectInput.svg'
import classNames from 'classnames'
import checkImg from '../../assets/checkImg.svg'
import habittation from '../../assets/habittation.svg'
import FlagTND from '../../assets/flagTunisie.svg'
import maghrebia from '../../assets/maghrebia.svg'

import { io, Socket } from 'socket.io-client'
// Define the type for your socket state
type SocketType = Socket | null

interface props {
  produitAssurance: string
  setProduitAssurance: (value: string) => void
  partenaireAssurance: string
  setPartenaireAssurance: (value: string) => void
  setNumStep: any
  functionTracks: any
}
const Produit: React.FC<props> = ({
  produitAssurance,
  setProduitAssurance,
  partenaireAssurance,
  setPartenaireAssurance,
  setNumStep,
  functionTracks,
}) => {
  // const [socket, setSocket] = useState<SocketType>(null)

  // const [isOpenlistProduit, setIsOpenlistProduit] = useState(false)

  // const [isOpenlistPartenaire, setIsOpenlistPartenaire] = useState(false)

  // const [isAssurance, setIsAssurance] = useState(false)

  // const handleSelectProduit = (produit: any) => {
  //   setProduitAssurance(produit)
  // }

  // const handleSelectPartenaire = (partenaire: any) => {
  //   setPartenaireAssurance(partenaire)
  // }

  // useEffect(() => {
  //   const socketInstance = io('https://app-dev.api.myeasytransfer.com')
  //   setSocket(socketInstance)
    
  //   socketInstance.on('connect', () => {
  //     console.log('Connected to server')
  //   })
  
  //   socketInstance.on('message', (data) => {
  //     console.log(`Received message: ${data}`)
  //   })
  
  //   return () => {
  //     if (socketInstance) {
  //       socketInstance.disconnect()
  //     }
  //   }
  // }, [])


  return (
    <div>
        <div className=" h-[120px] ">
          <div className="h3">
            Pays <span className="text-red-500">*</span>
          </div>
          <div className="  bg-[#F9FAFB] rounded-xl mt-3 h-[56px] w-full flex items-center  p-1">
            <img src={FlagTND} className="w-8 h-8 ml-3" />
            <div className="font-bold text-[18px] text-[#0C266C] pl-5">Tunis</div>
          </div>
          
        </div>

      <div className=" h-[120px] mt-10 sm:mt-5 ">
        <div className="h3">
          Sélectionnez le produit d’assurance <span className="text-red-500">*</span>
        </div>

        <div className=" items-center inline-block mt-3 w-full">
          <div className="text-[#1D3A70] text-[15px] font-semibold p-2 bg-[#F9FAFB] rounded-xl h-[56px]">
            <div className="flex items-center p-1">
              <img src={habittation} className="w-8 h-8 ml-3" />
              <div className="font-bold text-[18px] text-[#0C266C] pl-5">Assurance habitation</div>
            </div>
          </div>
          
        </div>
      </div>

      <div className={` h-[120px] mt-10 sm:mt-5 `}>
        <div className="font-bold text-[18px] text-[#1D3A70]">
          Assurance Partenaire <span className="text-red-500">*</span>
        </div>
        <div className="flex items-center mt-3 p-2 w-full border-[#5653E4] border-2 rounded-xl">
          <img src={maghrebia} className="w-8 h-8 ml-3" />
          <div className="font-bold text-[18px] text-[#0C266C] pl-5">Maghrebia</div>
          <img src={checkImg} className="w-6 h-6 ml-3" />
        </div>
       
      </div>

      <div className="flex gap-[16px] mt-[25px] justify-center w-full h-[56px] sm:px-4 ">
        <button
          className={classNames(
            'text-[18px] text-[#FFF] bg-[#4743C9] hover:cursor-pointer px-[28px] py-[16px] md:my-0 rounded-lg w-[375px] sm:w-full ',
          )}
          onClick={() => {
            setNumStep(1)
            functionTracks(1)
          }}
          // disabled={
          //   produitAssurance === ''
          //     ? 
          //       true
          //     : false
          // }
        >
          Suivant
        </button>
      </div>
    </div>
  )
}
export default Produit
